/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { ClusterAccessor } from '../../../../../../types/common/Accessors';
import {
  CancelDatasetDataType,
  DeleteDatasetDataType,
  ReimportDatasetDataType,
  SetDatasetNotReadonlyDataType,
} from '../../DatasetsTab.types';
import { DatasetImportsTablePersistingState } from './DatasetImportsTable.types';

export type DatasetImportsTableContextType = DatasetImportsTablePersistingState & {
  toggleDatabaseCollapsed: (databaseName: string) => any;
  toggleSchemaCollapsed: (schemaName: string, databaseName: string) => any;
  handleCancelDatasetData: (props: CancelDatasetDataType) => void;
  handleReimportDatasetData: (props: ReimportDatasetDataType) => void;
  handleDeleteDatasetData: (props: DeleteDatasetDataType) => void;
  handleSetNotReadonlyDatasetData: (props: SetDatasetNotReadonlyDataType) => void;
  isCollapsedDatabase: (databaseName: string) => boolean;
  isCollapsedSchema: (schemaName: string, databaseName: string) => boolean;
  clusterAccessor: ClusterAccessor;
};

const defaultContextValue: DatasetImportsTableContextType = {
  selectedDatabase: null,
  collapseDatabases: {},
  toggleDatabaseCollapsed: () => {},
  collapseSchemas: {},
  toggleSchemaCollapsed: () => {},
  handleCancelDatasetData: () => {},
  handleReimportDatasetData: () => {},
  handleDeleteDatasetData: () => {},
  handleSetNotReadonlyDatasetData: () => {},
  isCollapsedDatabase: () => false,
  isCollapsedSchema: () => false,
  clusterAccessor: {
    organizationId: '',
    projectId: '',
    clusterId: '',
  },
};

const DatasetImportsTableContext = React.createContext(defaultContextValue);

export { DatasetImportsTableContext };
